import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  type Unsubscribe,
} from "firebase/firestore";
import { db } from "../firebase";
import type { InboxItem } from "../utils/inbox";

// In-app notification inbox (#133): reads users/{uid}/inbox written by the
// backend dispatcher. Realtime subscription + mark-as-read.

const MAX_ITEMS = 50;

/**
 * Subscribe to a user's inbox, newest first. Returns an unsubscribe function.
 */
export function subscribeInbox(
  uid: string,
  onItems: (items: InboxItem[]) => void,
): Unsubscribe {
  const q = query(
    collection(db, "users", uid, "inbox"),
    orderBy("createdAt", "desc"),
    limit(MAX_ITEMS),
  );
  return onSnapshot(q, (snap) => {
    const items = snap.docs.map((d) => ({
      id: d.id,
      ...(d.data() as Omit<InboxItem, "id">),
    }));
    onItems(items);
  });
}

/** Mark a single inbox item read. */
export async function markInboxRead(uid: string, id: string): Promise<void> {
  await updateDoc(doc(db, "users", uid, "inbox", id), { read: true });
}
